export const parseIntegerInput = (rawValue) => {
  if (rawValue === null || rawValue === undefined || String(rawValue).trim() === '') return '';
  const parsed = parseInt(rawValue, 10);
  return Number.isNaN(parsed) ? '' : parsed;
};

export const integerInputValue = (value, unsetDisplayValue = '') => {
  if (value === null || value === undefined) return unsetDisplayValue;
  if (Number.isNaN(value)) return '';
  return value;
};

export const integerOrDefault = (value, defaultValue) => {
  const parsed = parseIntegerInput(value);
  return parsed === '' ? defaultValue : parsed;
};
